import { Routes } from "@angular/router"

export const appRoutes: Routes = [
	{ path: "", loadChildren: () => import(`./pages/pages-routes`).then(mod => mod.routes) }
]
